import React, { PureComponent } from 'react'
import { Icon, Button, Form, Modal } from 'semantic-ui-react'
import NameField from '../fields/nameField'

class DriverSegmentForm extends PureComponent {
  btnSubmitRef = React.createRef()

  onSave = e => {
    const { saveDriverSegment } = this.props
    e.preventDefault()
    saveDriverSegment()
  }

  render() {
    const { visible, action, onClose, onFieldChange, driverSegmentData, loading } = this.props

    return(
      <Modal open={visible} size="small" style={{ marginTop: 0 }}>
        <Modal.Header content={ action === "edit" ? "Edit Driver Segment" : "New Diver Segment"} />
        <Modal.Content>
          <Form
            onSubmit={this.onSave}
            ref={ref => {
              this.formRef = ref
            }}
            disabled={loading}
          >
            <Form.Group widths="equal">
              <NameField
                onChange={onFieldChange}
                value={driverSegmentData.name}
                field="name"
                label="Name"
              />
            </Form.Group>
            <button
              type="submit"
              hidden
              ref={ref => {
                this.btnSubmitRef = ref
              }}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose}
            disabled={loading}
          >
            Close
          </Button>
          <Button
            icon
            color="black"
            onClick={() => this.btnSubmitRef.click()}
            loading={loading}
            disabled={loading}
          >
            <Icon name="checkmark" /> Save
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

export default DriverSegmentForm


// WEBPACK FOOTER //
// ./src/components/drivers/forms/driverSegmentForm.js